import React from 'react';
import PropTypes from 'prop-types';
import { string } from 'yup';
import NumberFormat from 'react-number-format';
import BaseInput from '../base';

const validate = val =>
  string()
    .required('Contact Number (optional)')
    .min(10, 'Please enter a valid contact number')
    .validate(val.replace(/[^\d]/g, '').toString())
    .then(() => null)
    .catch(err => err.errors.join(', '));

const Input = inputProps => (
  <BaseInput
    label="Contact Number (optional)"
    type="tel"
    name="loanOfficerPhone"
    maxLength={15}
    transparent
    useLocalState={false}
    {...inputProps}
  />
);

const LoanOfficerPhone = ({ onTouched, onChange, ...rest }) => (
  <NumberFormat
    format="(###) ###-####"
    mask="_"
    onValueChange={values =>
      onChange({ ...values, name: 'loanOfficerPhone', type: 'tel' }, validate)
    }
    {...rest}
    customInput={Input}
  />
);

LoanOfficerPhone.propTypes = {
  onChange: PropTypes.func.isRequired,
  onTouched: PropTypes.func.isRequired,
  value: PropTypes.string,
  error: PropTypes.string
};

LoanOfficerPhone.defaultProps = {
  value: '',
  error: ''
};

export default LoanOfficerPhone;
